import React from "react";

import styled from "veneer/styled";

import TargetCard from "./TargetCard";

export interface ItemLike {
  duration?: number;
  id: number | string;
  name?: string;
  type?: string;
  url?: string;
}

interface DraggableTargetCardOwnProps {
  index: number;
  item: ItemLike;
  onChangeDuration: (duration: number, item: ItemLike) => void;
  onDelete: (item: ItemLike) => void;
  onDragEnd: () => void;
  onDragEnter: (hoverIndex: number) => void;
  onDragStart: (dragIndex: number) => void;
}

const DraggableContentIndex = styled("div")({
  border: 0,
  borderRadius: "50%",
  color: "#fff",
  display: "block",
  fontWeight: 600,
  height: 15,
  left: -5,
  lineHeight: "15px",
  position: "absolute",
  textAlign: "center",
  top: -5,
  width: 15,
  zIndex: 1,
  backgroundColor: "#3c8dbc",
});

const DraggableContentDelete = styled("button")({
  background: "#fff",
  border: 0,
  borderRadius: "50%",
  color: "#ccc",
  display: "block",
  height: 15,
  lineHeight: "15px",
  padding: 0,
  position: "absolute",
  right: -5,
  textAlign: "center",
  top: -5,
  width: 15,
  zIndex: 1,
});

function DraggableTargetCard({
  index,
  item,
  onChangeDuration,
  onDelete,
  onDragEnd,
  onDragEnter,
  onDragStart,
}: DraggableTargetCardOwnProps) {
  const contentStyle = {
    display: "inline-block",
    marginRight: index % 4 === 3 ? 0 : 15,
    cursor: "move",
    position: "relative",
    verticalAlign: "top",
  } as const;

  return (
    <div
      draggable
      onDragEnd={onDragEnd}
      onDragEnter={(event) => {
        event.preventDefault();
        onDragEnter(index);
      }}
      onDragOver={(event) => {
        event.preventDefault();
      }}
      onDragStart={(event) => {
        event.dataTransfer.effectAllowed = "move";
        event.dataTransfer.setData("text/plain", String(index));
        onDragStart(index);
      }}
      style={contentStyle}
    >
      <DraggableContentIndex>{index + 1}</DraggableContentIndex>
      <DraggableContentDelete onClick={() => onDelete(item)}>
        <i className="fa fa-lg fa-times-circle" />
      </DraggableContentDelete>
      <TargetCard
        details={{
          duration: item.duration,
          icon: item.url,
          name: item.name,
          type: item.type,
        }}
        id={item.id}
        onChangeDuration={(duration) => onChangeDuration(duration, item)}
      />
    </div>
  );
}

export default DraggableTargetCard;
